import React from 'react';
import useAuthStore from '../store/authStore';
import { StarIcon } from '@heroicons/react/24/solid';
import PageHeader from '../components/PageHeader';
import AdminDashboard from '../components/dashboard/AdminDashboard';
import ContractorDashboard from '../components/dashboard/ContractorDashboard';
import VipDashboard from '../components/dashboard/VipDashboard';
import CustomerDashboard from '../components/dashboard/CustomerDashboard';
import SimplePullToRefresh from '../components/SimplePullToRefresh';

const Home = () => {
  const { user } = useAuthStore();
  const [searchInput, setSearchInput] = React.useState('');
  const [refreshKey, setRefreshKey] = React.useState(0);
  
  const handleRefresh = async () => {
    // 컴포넌트를 강제로 리렌더링하여 데이터를 다시 가져오게 함
    setRefreshKey(prev => prev + 1);
    // 실제로는 여기서 API를 직접 호출하거나 React Query의 refetch를 사용
    await new Promise(resolve => setTimeout(resolve, 1000));
  };

  // 사용자 타입에 따라 다른 대시보드 렌더링
  const renderDashboard = () => {
    switch (user?.user_type) {
      case 'admin':
        return <AdminDashboard key={refreshKey} />;
      case 'contractor':
        return <ContractorDashboard key={refreshKey} />;
      case 'vip_customer':
        return <VipDashboard key={refreshKey} />;
      case 'customer':
        return <CustomerDashboard key={refreshKey} />;
      default:
        return <CustomerDashboard key={refreshKey} />;
    }
  };

  return (
    <SimplePullToRefresh onRefresh={handleRefresh} refreshMessage="대시보드가 업데이트되었습니다!" showDataCount={false}>
      <div className={`min-h-screen ${user?.user_type === 'vip_customer' ? 'bg-gradient-to-br from-purple-50 via-white to-pink-50' : 'bg-gray-50'}`}>
      {/* VIP 고객 전용 헤더 */}
      {user?.user_type === 'vip_customer' && (
        <div className="bg-gradient-to-r from-purple-600 to-pink-600 text-white px-4 py-2">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <StarIcon className="h-5 w-5 text-yellow-300" />
              <span className="text-sm font-medium">VIP 고객님 환영합니다</span>
            </div>
            <button
              onClick={() => window.location.href = '/vip'}
              className="text-sm font-medium hover:text-yellow-300 transition-colors"
            >
              내 리워드 확인 →
            </button>
          </div>
        </div>
      )}

      {/* 공통 헤더 */}
      <PageHeader 
        title="홈"
        isHome={true}
        searchInput={searchInput}
        setSearchInput={setSearchInput}
      />

      {/* 대시보드 컨텐츠 */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        {renderDashboard()}
      </div>
    </div>
    </SimplePullToRefresh>
  );
};

export default Home;